import React from 'react';

// 通用表格：headers 是表头，data 是每一行要展示的单元格。
// 页面里只需要维护 headers 和 data，就能快速搭出一个列表页。
export default function TableLayout({ headers, data, selectable = false }) {
  return (
    <div className="overflow-x-auto border border-gray-200 rounded-sm">
      <table className="w-full text-left border-collapse text-[13px] text-gray-700 whitespace-nowrap min-w-max">
        <thead>
          <tr className="bg-[#fafafa] border-b border-gray-200">
            {selectable && <th className="py-3 px-4 w-10"><input type="checkbox" className="cursor-pointer rounded border-gray-300 text-[#1890ff] focus:ring-[#1890ff]" /></th>}
            <th className="py-3 px-4 font-medium text-gray-800 w-12">序号</th>
            {headers.map((h, i) => {
              const isLast = i === headers.length - 1;
              return (
                <th key={i} className={`py-3 px-4 font-medium text-gray-800 ${isLast ? 'sticky right-0 bg-[#fafafa] z-10 shadow-[-2px_0_10px_rgba(0,0,0,0.05)] border-l border-gray-200 text-center' : ''}`}>
                  {h}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? data.map((row, i) => (
            <tr key={i} className="border-b border-gray-100 hover:bg-[#f8f9fa] transition-colors group">
              {selectable && <td className="py-3 px-4"><input type="checkbox" className="cursor-pointer rounded border-gray-300 text-[#1890ff] focus:ring-[#1890ff]" /></td>}
              <td className="py-3 px-4 text-gray-500">{i + 1}</td>
              {row.map((cell, j) => {
                const isLast = j === row.length - 1;
                return (
                  <td key={j} className={`py-3 px-4 ${isLast ? 'sticky right-0 bg-white z-10 shadow-[-2px_0_10px_rgba(0,0,0,0.05)] group-hover:bg-[#f8f9fa] border-l border-gray-100 text-center' : ''}`}>
                    {cell}
                  </td>
                );
              })}
            </tr>
          )) : (
            <tr>
              <td colSpan={headers.length + (selectable ? 2 : 1)} className="py-8 text-center text-gray-400">暂无数据</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
